import { LazyPage, PipelineSourcesJourneysPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function PipelineSourcesJourneysRoute() {
  return (
    <LazyPage>
      <PipelineSourcesJourneysPage />
    </LazyPage>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/pipelines/sources/journeys')({
  component: PipelineSourcesJourneysRoute,
});
